import React from 'react';
import { movdFocus, movdTokens } from './movdTokens.js';

const variants = {
  primary: { background: movdTokens.color.brand.primary, color: movdTokens.color.brand.text, border: '1px solid transparent' },
  secondary: { background: 'transparent', color: movdTokens.color.content.primary, border: `1px solid ${movdTokens.color.border.soft}` },
  ghost: { background: 'transparent', color: movdTokens.color.brand.primary, border: '1px solid transparent' },
  warm: { background: movdTokens.color.warm, color: movdTokens.color.ink, border: '1px solid transparent' },
};

export default function MovdButton({ variant = 'primary', loading = false, children, style, ...props }) {
  const tone = variants[variant] || variants.primary;
  const isInteractive = !props.disabled && !loading;
  return (
    <button
      type="button"
      {...props}
      disabled={props.disabled || loading}
      style={{
        ...tone,
        minHeight: 48,
        padding: '0 20px',
        borderRadius: movdTokens.radius.md,
        font: 'inherit',
        fontSize: 14,
        fontWeight: movdTokens.typography.weight.extrabold,
        letterSpacing: '.01em',
        cursor: isInteractive ? 'pointer' : 'not-allowed',
        opacity: isInteractive ? 1 : .5,
        transition: `all ${movdTokens.motion.micro}`,
        ...style,
      }}
      onFocus={event => {
        event.currentTarget.style.outline = movdFocus.outline;
        event.currentTarget.style.outlineOffset = `${movdFocus.outlineOffset}px`;
        props.onFocus?.(event);
      }}
      onBlur={event => {
        event.currentTarget.style.outline = '';
        props.onBlur?.(event);
      }}
      onMouseDown={event => {
        if (isInteractive) event.currentTarget.style.transform = 'translateY(1px)';
        props.onMouseDown?.(event);
      }}
      onMouseUp={event => {
        event.currentTarget.style.transform = '';
        props.onMouseUp?.(event);
      }}
      onMouseEnter={event => {
        if (isInteractive) {
          event.currentTarget.style.background = variant === 'primary' ? movdTokens.color.brand.primaryHover : variant === 'secondary' ? movdTokens.color.background.muted : tone.background;
          event.currentTarget.style.borderColor = variant === 'secondary' ? movdTokens.color.brand.primary : tone.border;
        }
        props.onMouseEnter?.(event);
      }}
      onMouseLeave={event => {
        event.currentTarget.style.background = tone.background;
        event.currentTarget.style.borderColor = tone.border;
        event.currentTarget.style.transform = '';
        props.onMouseLeave?.(event);
      }}
    >
      {loading ? 'Working…' : children}
    </button>
  );
}
